/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MailBankSendPackageStatusAlertRequest
 */
export interface MailBankSendPackageStatusAlertRequest {
    /**
     * 
     * @type {string}
     * @memberof MailBankSendPackageStatusAlertRequest
     */
    packageId?: string;
}

/**
 * Check if a given object implements the MailBankSendPackageStatusAlertRequest interface.
 */
export function instanceOfMailBankSendPackageStatusAlertRequest(value: object): value is MailBankSendPackageStatusAlertRequest {
    return true;
}

export function MailBankSendPackageStatusAlertRequestFromJSON(json: any): MailBankSendPackageStatusAlertRequest {
    return MailBankSendPackageStatusAlertRequestFromJSONTyped(json, false);
}

export function MailBankSendPackageStatusAlertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailBankSendPackageStatusAlertRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'packageId': json['packageId'] == null ? undefined : json['packageId'],
    };
}

export function MailBankSendPackageStatusAlertRequestToJSON(json: any): MailBankSendPackageStatusAlertRequest {
    return MailBankSendPackageStatusAlertRequestToJSONTyped(json, false);
}

export function MailBankSendPackageStatusAlertRequestToJSONTyped(value?: MailBankSendPackageStatusAlertRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'packageId': value['packageId'],
    };
}

